import * as t from './actionTypes';

const errorCode = (error) => {
  // console.log('flight load error:', error);
  if (error && error.status === 429) {
    return 'TOO_MANY_REQUESTS';
  }
  return 'FLIGHT_LOAD_ERROR1';
};

const initialState = {
  loading: false,
  loaded: false,
  refreshCount: -1,
  segments: [],
  flight: {},
  secondarySearchAction: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case t.LOAD_BY_ID:
      return {
        ...state,
        loading: true,
        refreshCount: -1,
      };
    case t.LOAD_BY_CARRIER_FLIGHT_NUMBER_AND_DATE:
      return {
        ...state,
        loading: true,
        refreshCount: -1,
      };
    case t.LOAD_EXTENDED_DETAILS_BY_CARRIER_FLIGHT_NUMBER_AND_DATE:
      return {
        ...state,
        loading: true,
        refreshCount: -1,
      };
    case t.LOAD_EXTENDED_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        extendedData: action.result,
        error: null,
        refreshCount: state.refreshCount + 1,
      };
    case t.LOAD_BY_CARRIER_FLIGHT_NUMBER_AND_DATE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        segments: action.result,
        error: null,
        refreshCount: state.refreshCount + 1,
      };
    case t.LOAD_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        flight: action.result,
        error: null,
        refreshCount: state.refreshCount + 1,
      };
    case t.LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        // data: null, // Do not nil out .data here so that downstream handler can be responsible.
        error: Object.assign({}, action.error, { code: errorCode(action.error) }),
        refreshCount: state.refreshCount + 1,
      };
    case t.UPDATE_SEGMENTS:
      return {
        ...state,
        segments: action.segments,
      };
    case t.SET_SECONDARY_SEARCH_ACTION:
      return {
        ...state,
        secondarySearchAction: action.bool,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./modules/SingleFlight/redux/reducer.js